<template>
  <div class="data-input pb-1" :class="isValid?'valid':'invalid'">
    <label v-if="label" :for="id" class="">{{ label }}</label>
    <div class="position-relative">
      <input :type="type" :id="id" class="custom-control"
             :value="value"
             :disabled="disabled"
             :step="step"
             :placeholder="placeholder"
             :inputmode="inputMode"
             :list="datalistId"
             :required="required"
             @input="onInput"
             @focusin="$emit('focusin')"
             @focusout="$emit('focusout')"
      >
      <slot name="onFocus"/>
      <span class="unit-offset-wrap"><span v-if="(value === 0 || value) && isValid" class="unit-offset">{{ value }}&nbsp;</span>{{
          unit
        }}</span>

    </div>
    <p v-if="value > maxValue" class="text-danger pl-2 my-0 small">{{ maxValueWaring }}</p>
  </div>
</template>

<script>
import uuid from 'uuid'

export default {
  name: "DataInput",
  props: {
    label: String,
    placeholder: String,
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: String | Number,
    maxValue: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    step: {
      type: Number,
      default: 1
    },

    maxValueWaring: String,
    unit: String,
    datalistId: String,
    required: {type: Boolean, default: false}
  },
  data() {
    return {
      id: 'id_' + uuid(),
      isValid: true
    }
  },
  computed: {
    inputMode() {
      switch (this.type) {
        case 'number':
          return 'decimal';
        case 'email':
        case 'tel':
        case 'url':
          return this.type
        default:
          return 'text';
      }
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
      if (this.type === 'number') {
        this.isValid = e.target.validity.valid && (e.target.value <= this.maxValue);
      }
    }
  }
}
</script>
